import { Backdrop, CircularProgress } from "@mui/material"; 
export const Loader = ({ loading }) => {
  return (
    <Backdrop
      open={loading}
      sx={(theme) => ({
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      })}
    >
      <CircularProgress />
    </Backdrop>
  );
};

export default Loader;